'use es6';

import { AD_NETWORK_FACEBOOK, AD_OBJECT_AD } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { ADS_FACEBOOK_ADS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchAdsObjectSearchPageForNetwork, createFetchAdsObjectsByIdsForNetwork, fetchAdsObjectsByIdsForNetwork, fetchAdsObjectSearchPageForNetwork } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsFacebookAdsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_FACEBOOK_ADS,
  createFetchByIds: opts => createFetchAdsObjectsByIdsForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPageForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD),
  fetchByIds: fetchAdsObjectsByIdsForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD),
  fetchSearchPage: fetchAdsObjectSearchPageForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD)
}, options));
export default createAdsFacebookAdsReferenceResolver();